import { Link2Icon } from '@radix-ui/react-icons';
import { Text } from '@radix-ui/themes';
import { CommonTooltip } from 'components/common/tooltip';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IVideo } from 'lib_ts/interfaces/i-video';

export const VideoStatsApiIcon = (props: { video: IVideo }) => {
  if (!props.video.mlb_pitcher) {
    return null;
  }

  return (
    <CommonTooltip
      text="Pitcher details are from MLB Stats API"
      trigger={
        <Text color={RADIX.COLOR.SUCCESS}>
          <Link2Icon style={{ marginTop: RADIX.ICON.TABLE_MT }} />
        </Text>
      }
    />
  );
};
